import React from 'react';
import PropTypes from 'prop-types';
import { Typography, TextField, Grid } from '@material-ui/core';

class PeselFragment extends React.Component {
  static parseInputValue = (inputValue, mask) => {
    if (!inputValue) {
      return mask.map(() => '');
    }
    
    // Convert input string to array of values based on mask
    const values = [];
    for (let i = 0; i < mask.length; i++) {
      if (i < inputValue.length) {
        const char = inputValue[i];
        // Only use the character if it's a digit and the mask allows input at this position
        values[i] = (mask[i] && char !== '_' && /^\d$/.test(char)) ? char : '';
      } else {
        values[i] = '';
      }
    }
    return values;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // Update state when input.value changes from outside
    if (nextProps.input.value !== prevState.prevInputValue) {
      const newValues = PeselFragment.parseInputValue(nextProps.input.value, nextProps.peselFragmentMask);
      return {
        values: newValues,
        prevInputValue: nextProps.input.value,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);

    this.state = {
      values: PeselFragment.parseInputValue(props.input.value, props.peselFragmentMask),
      prevInputValue: props.input.value,
    };
  }

  parseInputValue = (inputValue, mask) => {
    return PeselFragment.parseInputValue(inputValue, mask);
  }

  /*handleKeyPress = (e, fieldName) => {
    const fieldNumber = fieldName.replace('pesel', '');
    const nextFieldNumber = parseInt(fieldNumber) + 1;
    //this.refs[`pesel${nextFieldNumber}`].focus();
  }*/

  handleChange = (index, value) => {
    const newValues = [...this.state.values];
    if (!value || (value.length === 1 && Number.isInteger(parseInt(value)))) {
      newValues[index] = value;
      this.setState(
        { values: newValues },
        () => {
          const outputValue = this.props.peselFragmentMask.filter(v => v).length === this.state.values.filter(v => v).length
            ? this.state.values.map(v => v ? v : '_').join('')
            : '';
          
          this.props.input.onChange(outputValue);
          this.props.input.onBlur();
          
          // Update prevInputValue to match what we just set
          this.setState({ prevInputValue: outputValue });
        }
      );
    }
  };

  render() {
    const {
      label,
      meta: { touched, error },
      disabled,
      peselFragmentMask,
      helperText
    } = this.props;
    const { values } = this.state;

    return (
      <div style={{marginTop: 18, margiBottom: 12}}>
        <Typography variant="caption">{label}</Typography>
        <Grid container spacing={1} justify="flex-start" alignItems="center">
          {peselFragmentMask.map((value, index) => (
            <Grid item key={index}>
              <TextField
                disabled={disabled || !value}
                value={values[index]}

                onChange={e => this.handleChange(index, e.target.value)}
                name={`pesel${index}`}
                ref={`pesel${index}`}
                inputProps={{ref: this.name}}
                //onKeyPress={e => this.handleKeyPress(e, `pesel${index}`)}
                style={!value ? { backgroundColor: '#f1f1f1', width: 20 } : { width: 20 }}
              />
            </Grid>
          ))}
        </Grid>
        {touched && error ? <Typography variant="caption" color="error">{error}</Typography> : null}
        {helperText && <Typography variant="caption" component="div">{helperText}</Typography>}
      </div>
    );
  }
}

PeselFragment.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  disabled: PropTypes.bool,
  peselFragmentMask: PropTypes.array.isRequired,
  helperText: PropTypes.string,
};

export default PeselFragment;



// WEBPACK FOOTER //
// ./src/components/legacyForm/PeselFragmentField.js